import styled from 'styled-components'
import AnimatedSprite from './AnimatedSprite'

const ItemImageAnimated = styled(AnimatedSprite)`
  display: block;
  pointer-events: ${p => p.pointerEvents || 'none'};
  width: 100%;
`

export default ItemImageAnimated



// WEBPACK FOOTER //
// ./src/components/ItemImageAnimated.js